import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  getIsPublishing,
  getPublishError,
  getIsApproving,
  getApproveError,
  getUnpublishError,
  getIsUnpublishing,
  getDicardDraftError,
  getIsDiscardingDraft,
  getMarkAsUptoDateError,
  getIsMarkingAsUptoDate,
  getIsSendingForReview,
  getSendReviewError,
  getIsglobalApproving,
  getGlobalApproveError,
  getIsglobalRejecting,
  getGlobalRejectError,
  getIsImportingGlobalUpdate,
  getimportingGlobalUpdateError
} from '../selectors';
import {
  publishPpsi,
  approvePpsi,
  unpublishPpsi,
  discardDraftPpsi,
  markAsUptoDatePpsi,
  importiFoodUpdatePpsi,
  importGlobalUpdatePpsi,
  sendPpsiForGlobalReview,
  approveGlobalReviewPpsi,
  rejectGlobalReviewPpsi,
  publishEmptyPpsi
} from '../actions';

const Action = {
  APPROVE: {
    reduxAction: approvePpsi,
    getRunningSelector: getIsApproving,
    getErrorSelector: getApproveError
  },
  PUBLISH: {
    reduxAction: publishPpsi,
    getRunningSelector: getIsPublishing,
    getErrorSelector: getPublishError
  },
  PUBLISH_EMPTY_PPSI: {
    reduxAction: publishEmptyPpsi,
    getRunningSelector: getIsApproving,
    getErrorSelector: getApproveError
  },
  UNPUBLISH: {
    reduxAction: unpublishPpsi,
    getRunningSelector: getIsUnpublishing,
    getErrorSelector: getUnpublishError
  },
  DISCARD_DRAFT: {
    reduxAction: discardDraftPpsi,
    getRunningSelector: getIsDiscardingDraft,
    getErrorSelector: getDicardDraftError
  },
  MARKASUPTODATE: {
    reduxAction: markAsUptoDatePpsi,
    getRunningSelector: getIsMarkingAsUptoDate,
    getErrorSelector: getMarkAsUptoDateError
  },
  IMPORT_IFOOD_UPDATE_PPSI: {
    reduxAction: importiFoodUpdatePpsi,
    getRunningSelector: getIsMarkingAsUptoDate,
    getErrorSelector: getMarkAsUptoDateError
  },

  IMPORT_GLOBAL_UPDATE_PPSI: {
    reduxAction: importGlobalUpdatePpsi,
    getRunningSelector: getIsImportingGlobalUpdate,
    getErrorSelector: getimportingGlobalUpdateError
  },
  SUBMIT_FOR_GLOBAL_REVIEW: {
    reduxAction: sendPpsiForGlobalReview,
    getRunningSelector: getIsSendingForReview,
    getErrorSelector: getSendReviewError
  },
  GLOBAL_APPROVE: {
    reduxAction: approveGlobalReviewPpsi,
    getRunningSelector: getIsglobalApproving,
    getErrorSelector: getGlobalApproveError
  },
  GLOBAL_REJECT: {
    reduxAction: rejectGlobalReviewPpsi,
    getRunningSelector: getIsglobalRejecting,
    getErrorSelector: getGlobalRejectError
  }
};

const usePpsiAction = action => {
  const [isStarted, setIsStarted] = useState(false);
  const [isCompleted, setIsCompleted] = useState(false);
  const dispatch = useDispatch();
  const isRunning = useSelector(action.getRunningSelector);
  const error = useSelector(action.getErrorSelector);
  const isDoneWithoutError = isStarted && !isRunning && !error;

  if (action.debug) {
    // console.log('usePpsiAction()', action);
    // console.log('   -- isStarted', isStarted);
    // console.log('   -- isCompleted', isCompleted);
    // console.log('   -- isRunning', isRunning);
    // console.log('   -- error', error);
    // console.log('   -- isDoneWithoutError', isDoneWithoutError);
  }

  if (isDoneWithoutError) {
    if (!isCompleted) {
      if (action.debug) {
        // console.log(' --> Mark as completed');
      }
      setIsCompleted(true);
    }
  }

  const performAction = (id, data) => {
    // console.log('usePpsiAction().perform()', id, data, action);
    dispatch(action.reduxAction(id, data));
    setIsStarted(true);
  };

  return [performAction, isRunning, isCompleted];
};

export const useApprovePpsi = () => usePpsiAction(Action.APPROVE);
export const usePublishEmptyPpsi = () =>
  usePpsiAction(Action.PUBLISH_EMPTY_PPSI);
export const usePublishPpsi = () => usePpsiAction(Action.PUBLISH);
export const useUnpublishPpsi = () => usePpsiAction(Action.UNPUBLISH);
export const useDiscardDraftPpsi = () => usePpsiAction(Action.DISCARD_DRAFT);
export const useSendReviewPpsi = () =>
  usePpsiAction(Action.SUBMIT_FOR_GLOBAL_REVIEW);
export const useGlobalApprovePpsi = () => usePpsiAction(Action.GLOBAL_APPROVE);
export const useGlobalRejectPpsi = () => usePpsiAction(Action.GLOBAL_REJECT);
export const useMarkAsUptoDatePpsi = () => usePpsiAction(Action.MARKASUPTODATE);
export const useImportiFoodUpdatePpsi = () =>
  usePpsiAction(Action.IMPORT_IFOOD_UPDATE_PPSI);
export const useImportGlobalUpdatePpsi = () =>
  usePpsiAction(Action.IMPORT_GLOBAL_UPDATE_PPSI);
